import { useEffect, useRef } from 'react';

/**
 * Intercept browser/OS back while a workflow is active and run `onBack`
 * (step-backward semantics) instead of leaving a stale progress URL.
 */
export function useWorkflowBack(active: boolean, onBack: () => void | Promise<void>): void {
  const handlerRef = useRef(onBack);
  handlerRef.current = onBack;

  useEffect(() => {
    if (!active) return;
    const onPop = () => {
      void handlerRef.current();
    };
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, [active]);
}
